import { render, staticRenderFns } from "./EducationManage.vue?vue&type=template&id=142c35fb&scoped=true"
import script from "./EducationManage.vue?vue&type=script&lang=js"
export * from "./EducationManage.vue?vue&type=script&lang=js"
import style0 from "./EducationManage.vue?vue&type=style&index=0&id=142c35fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142c35fb",
  null
  
)

export default component.exports